import Vue from 'vue'
import athletesTransformer from './../../transformers/athletes'
import store from './../../store'
import $ from 'jquery'

// When the request succeeds
const success = (athletes, exactMatch) => {
  athletes = athletesTransformer.fetchCollection(athletes)
  store.dispatch('setAthletes', athletes)
  if (exactMatch) {
    const athlete = athletes[0]
    store.dispatch('setPage', {
      title: athlete.name,
      subtitle: `Graduated in ${athlete.year}`,
    })
  }
}

// When the request fails
const failed = () => {
}

export default (searchTermF, searchTermL, searchTermY, exactMatch) => {
  let urlAthleteSearch = process.env.PPDB_API_LOCATION + '/cgi-bin/people2?'
  const searchArgs = `c=athletics&f=${searchTermF}&l=${searchTermL}&y=${searchTermY}`
  urlAthleteSearch += searchArgs
  Vue.http.get(urlAthleteSearch).then((response) => {
    let parsedData = []
    const $doc = $($.parseXML(response.data))
    $doc.find('pingry-person').each((key, value) => {
      const $person = $(value)
      parsedData.push({
        'constituent-id': $person.find('constituent-id').text(),
        'first-name': $person.find('first-name').text(),
        'last-name': $person.find('last-name').text(),
        'middle-name': $person.find('middle-name').text(),
        'maiden-name': $person.find('maiden-name').text(),
        'suffix-1': $person.find('suffix-1').text(),
        nickname: $person.find('nickname').text(),
        year: $person.find('primary-education-class-of-year').text(),
      })
    })

    success(parsedData, exactMatch)
  }, (response) => {
    failed(response)
  })
}
